import { createAction, props } from '@ngrx/store';
import { Position } from '../../../units/models/position';

export const getPositionsSuccess = createAction(
  '[Positions/API] Get Positions Success',
  props<{positions: Position[]}>()
);
export const getPositionsFailure = createAction(
  '[Positions/API] Get Positions Failure',
  props<{error: any}>()
);

export const updatePositionsSuccess = createAction(
  '[Positions/API] Update Positions Success',
  props<{positions: Position[]}>()
);

export type PositionsApiActionsUnion = ReturnType<
  typeof getPositionsSuccess |
  typeof getPositionsFailure |
  typeof updatePositionsSuccess
>;
